import { render } from "./PushManagement.vue?vue&type=template&id=0d754354&scoped=true"
import script from "./PushManagement.vue?vue&type=script&lang=js"
export * from "./PushManagement.vue?vue&type=script&lang=js"

import "./PushManagement.vue?vue&type=style&index=0&id=0d754354&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d754354"

export default script